module.exports = __webpack_public_path__ + "img/edit.700525b1.svg";